import { PerformanceMode } from '../targets'

/** Cap target to +30% */
export const MAX_TARGET_MULTIPLIER = 1.3
/** Cap target to -30% */
export const MIN_TARGET_MULTIPLIER = 0.7
/** Avoid target changes smaller than 3% */
export const MIN_TARGET_MULTIPLIER_AMPLITUDE = 0.03

export interface PerformanceTargetSettings {
    bidding_strategy: PerformanceMode
    target_cpa?: number
    target_roas?: number
    target_cpa_set: boolean
    target_roas_set: boolean
}

export interface Context {
    performance_target_settings: PerformanceTargetSettings
    environment: {
        cost: number
        all_conversions: number
        all_conversions_value: number
        force_cpa?: number
    }
    entity: {
        cost: number
        all_conversions: number
        all_conversions_value: number
        existing_target: number
    }
    campaign_is_budget_capped: boolean
}

export interface Result {
    new_target: number | undefined
    is_valid: boolean
    invalid_reason?: InvalidTargetReason
    environment: {
        cpa?: number
        roas?: number
        profit?: number
        roi?: number
    }
    entity: {
        cpa?: number
        roas?: number
        profit?: number
        roi?: number
    }
}

export enum InvalidTargetReason {
    TARGET_CHANGE_IS_TOO_SMALL = `TARGET_CHANGE_IS_TOO_SMALL`,
    TARGET_IN_WRONG_DIRECTION = `TARGET_IN_WRONG_DIRECTION`,
    BUDGET_CAPPED_CONSTRAINT = `ONLY_TARGET_TIGHTENING_ALLOWED_IF_BUDGET_CAPPED`,
}

export const Error = {
    NO_VALID_BIDDING_STRATEGY: 'no_valid_bidding_strategy',
    NO_VALID_ENTITY_TARGET: 'no_valid_entity_target',
    CPA_SET_WITH_NO_TARGET: 'cpa_set_with_no_target',
    ROAS_SET_WITH_NO_TARGET: 'roas_set_with_no_target',
    PROFIT_WITH_NO_MARGIN: 'profit_with_no_margin',
} as const

export type Error = (typeof Error)[keyof typeof Error]

export const ErrorReadable = {
    [Error.NO_VALID_BIDDING_STRATEGY]: `Unsupported bidding_strategy`,
    [Error.NO_VALID_ENTITY_TARGET]: `Couldn't find a valid existing target`,
    [Error.CPA_SET_WITH_NO_TARGET]: `CPA is set to true but could't find a CPA`,
    [Error.ROAS_SET_WITH_NO_TARGET]: `ROAS is set to true but could't find a ROAS`,
}
